export default __webpack_public_path__ + "static/media/a024-1.4e72f8ed.svg";